module.exports = __webpack_public_path__ + "img/3.a3b2db6f.jpg";